import { MemberDashboardHeader } from '~/modules/member-dashboard/components/layout/MemberDashboardHeader';
import { Button } from '@rocco/components/button';
import { AvatarCircles } from '@rocco/components/avatar-circles';
import type { BuildHub } from '../../types';
import { BuildHubDetailsHeaderMenu } from './BuildHubDetailsHeaderMenu';
import { useSetAtom } from 'jotai';
import { uiStateAtomManageCollabratorModalIsOpened } from '../build-hub-admin/ManageCollabratorModal';
import { getCollaboratorAvatar } from '../../utils/get-collaborator-avatar';
interface BuildHubDetailsHeaderProps {
    buildHub: BuildHub;
}

export const BuildHubDetailsHeader = ({
    buildHub,
}: BuildHubDetailsHeaderProps) => {
    const { collaborators, title } = buildHub;
    const setIsManageCollabratorModalOpen = useSetAtom(
        uiStateAtomManageCollabratorModalIsOpened
    );

    const handleAvatarClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsManageCollabratorModalOpen(true);
    };

    return (
        <MemberDashboardHeader
            title={title}
            actions={
                <div className="mt-1 flex items-center gap-2">
                    <div className="flex min-w-60 items-center justify-end">
                        <button
                            type="button"
                            className="cursor-pointer border-0 bg-transparent p-0"
                            onClick={handleAvatarClick}
                            aria-label="Open project team management"
                        >
                            <AvatarCircles
                                avatarUrls={collaborators.map(
                                    (collaborator) => ({
                                        imageUrl:
                                            getCollaboratorAvatar(collaborator),
                                        name:
                                            collaborator.name.length > 0
                                                ? collaborator.name
                                                : collaborator.email,
                                    })
                                )}
                            />
                        </button>
                    </div>
                    {buildHub.userPermissions.canEdit && (
                        <Button
                            color="dark"
                            textSize={'small'}
                            className="leading-[1.5rem]"
                            onClick={() =>
                                setIsManageCollabratorModalOpen(true)
                            }
                        >
                            Share
                        </Button>
                    )}
                    <BuildHubDetailsHeaderMenu
                        buildHubId={buildHub.id}
                        buildHubUrl={buildHub.urlSegment}
                        userPermissions={buildHub.userPermissions}
                        ownerId={buildHub.ownerId}
                    />
                </div>
            }
        />
    );
};
